module.exports = __webpack_public_path__ + "static/media/icon-account-mapping.c77fd844.svg";